<template>
  <AppForm :label="label">
    <v-layout wrap :justify-start="justifyStart" :justify-end="justifyEnd">
      <v-flex
        :xs3="!noSlot"
        :xs5="noSlot"
        style="max-width:200px; min-width: 120px;"
      >
        <v-menu
          v-model="startMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="120px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="startDate"
              prepend-icon="event"
              readonly
              class="pa-0 ma-0"
              hide-details
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="startDate"
            :max="datePickerMax"
            locale="ja"
            no-title
            scrollable
            :day-format="date => new Date(date).getDate()"
            @input="startMenu = false"
          />
        </v-menu>
      </v-flex>
      <v-flex xs1 style="text-align: center;">
        〜
      </v-flex>
      <v-flex
        :xs3="!noSlot"
        :xs5="noSlot"
        style="max-width:200px; min-width: 120px;"
      >
        <v-menu
          v-model="endMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="120px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="endDate"
              prepend-icon="event"
              readonly
              class="pa-0 ma-0"
              hide-details
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="endDate"
            :min="datePickerMin"
            locale="ja"
            no-title
            scrollable
            :day-format="date => new Date(date).getDate()"
            @input="endMenu = false"
          />
        </v-menu>
      </v-flex>
      <v-flex v-if="!noSlot" xs5>
        <slot />
      </v-flex>
    </v-layout>
  </AppForm>
</template>

<script>
import dayjs from 'dayjs'
export default {
  props: {
    label: {
      type: String,
      default: '表示期間',
    },
    defaultUseDateRange: {
      type: Boolean,
      default: false,
    },
    start: {
      type: String,
      default: '',
    },
    end: {
      type: String,
      default: '',
    },
    noSlot: {
      type: Boolean,
      default: false,
    },
    justifyStart: {
      type: Boolean,
      default: false,
    },
    justifyEnd: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // datepicker表示制御用
      startMenu: false,
      endMenu: false,
      useDateRange: undefined,
    }
  },
  computed: {
    datePickerMin() {
      // 初期値でエラーになるのを防ぐためのisValid
      return dayjs(this.startDate).isValid() ? this.startDate : undefined
    },
    datePickerMax() {
      return dayjs(this.endDate).isValid() ? this.endDate : undefined
    },
    startDate: {
      get() {
        return this.start
      },
      set(value) {
        const result = {
          startDate: value,
          endDate: this.endDate,
        }
        this.$emit('change', result)
      },
    },
    endDate: {
      get() {
        return this.end
      },
      set(value) {
        const result = {
          startDate: this.startDate,
          endDate: value,
        }
        this.$emit('change', result)
      },
    },
  },
}
</script>
